var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEditFile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6881 14.772L8.53613 15.5194L9.22813 11.312L17.1584 3.40938C17.2871 3.27966 17.4402 3.1767 17.6088 3.10644C17.7775 3.03618 17.9584 3 18.1411 3C18.3238 3 18.5047 3.03618 18.6733 3.10644C18.842 3.1767 18.9951 3.27966 19.1237 3.40938L20.5908 4.87642C20.7205 5.00508 20.8234 5.15815 20.8937 5.32681C20.964 5.49546 21.0001 5.67636 21.0001 5.85906C21.0001 6.04176 20.964 6.22266 20.8937 6.39131C20.8234 6.55997 20.7205 6.71304 20.5908 6.8417L12.6881 14.772Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.916 15.464V19.616C18.916 19.983 18.7702 20.335 18.5106 20.5946C18.2511 20.8541 17.899 21 17.532 21H4.384C4.01694 21 3.66491 20.8541 3.40536 20.5946C3.14581 20.335 3 19.983 3 19.616V6.46798C3 6.10092 3.14581 5.7489 3.40536 5.48935C3.66491 5.2298 4.01694 5.08398 4.384 5.08398H8.53599",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/editFile.404ef5db.svg";
export { ForwardRef as ReactComponent };